import { clearFormProgress, formProgressSync } from "../utils/formProgress";
import {
  getSearchParam,
  handleSubmitBtnState,
  showSwalMessage
} from "../utils/helpers";

const desktopTabs = document.querySelectorAll(".travel-info .tab");
const mobileTabs = document.querySelectorAll(".travel-mobile-nav .tab");
const tabPanes = document.querySelectorAll(".tab-pane");
const pageHeroSection = document.querySelector(".travel-info-hero-section");

// CONVERT ALL SELECT ELEMENTS TO SELECT2 DROPDOWNS AND DISABLE SARCH
$("select#countries").select2();
$("select").not("#countries").select2({
  minimumResultsForSearch: Infinity
});
// END

const requestId = getSearchParam("req_id");

const EnumRedirectParams = {
  travelInfo: "travel-info",
  travelBudget: "travel-budget",
  requestChanges: "request-changes"
};

const heroSections = [
  {
    formId: "travelHelp",
    formSyncId: "travel_help_form",
    className: "travel-info-hero",
    documentTitle: "Travel Info | Prelate Travels & Tours",
    swalAlertMsg: `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br /> Reaching out to us is the first step to get started on your journey!<br />We will get back to you with all of the information you'll need to get into the selected destination country.</b></h5>`
  },
  {
    formId: "travelBudget",
    formSyncId: "travel_budget_form",
    className: "travel-budget-hero",
    documentTitle: "Travel Budget | Prelate Travels & Tours",
    swalAlertMsg: `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br /> Thank you for reaching out to us with your travel budget and we're glad to tell you that it's doable!<br /><b>We will reach out to you as soonest.</b></h5>`
  },
  {
    formId: "changeRequest",
    formSyncId: "change_request_form",
    className: "change-request-hero",
    documentTitle: "Request Changes | Prelate Travels & Tours",
    swalAlertMsg: `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br /> We've gotten your change request and we will reach out to you as soonest.<br />Kindly copy this request ID and keep it safe: <b>${requestId}</b>. Use it to follow up with us when we reach out to you</h5>`
  }
]; //Arranged in order which the tabs are arranged in the html file

// select tab panes based on redirect urls params
const redirectParam = getSearchParam("redirect");
// console.log({ redirectParam });
if (redirectParam) {
  if (redirectParam === EnumRedirectParams.travelInfo) activateTab(0);
  else if (redirectParam === EnumRedirectParams.travelBudget) activateTab(1);
  else if (redirectParam === EnumRedirectParams.requestChanges) activateTab(2);
} else {
  // DEFAULT SETTINGS
  __onPageInit(heroSections[0]);
  // DEFAULT SETTINGS END
}

// Tabs && Tab panes
desktopTabs?.forEach((tab, index) =>
  tab.addEventListener("click", () => activateTab(index))
);
mobileTabs?.forEach((tab, index) =>
  tab.addEventListener("click", () => activateTab(index))
);

// FUNCTIONS
function activateTab(index) {
  const mobileActiveTab = document.querySelector(".travel-mobile-nav .active");
  const desktopActiveTab = document.querySelector(".travel-info .active");

  mobileActiveTab.classList.remove("active");
  desktopActiveTab.classList.remove("active");

  desktopTabs?.[index].classList.add("active");
  mobileTabs?.[index].classList.add("active");

  // Update page to use tab specific configuration
  const section = heroSections[index];
  if (section) {
    // update document title
    document.title = section.documentTitle;
    // remove all existing heroSection classes on pageHeroSection
    heroSections.forEach((i) => pageHeroSection.classList.remove(i.className));
    // add class to pageHeroSection
    pageHeroSection.classList.add(section.className);
  }

  // remove all tab panes and display clicked tab pane
  tabPanes.forEach((pane, paneIndex) => {
    if (paneIndex === index) {
      pane.style.display = "block";
      __onPageInit(heroSections[paneIndex]);
    } else pane.style.display = "none";
  });
}

function __onPageInit(heroSection) {
  //   console.log(heroSection);
  const { formSyncId, formId, swalAlertMsg } = heroSection;
  const selectedForm = document.querySelector(`#${formId}`);

  //  ENABLE FORM PROGRESS SYNC FOR TRAVEL HELP BY DEFAULT
  formProgressSync(selectedForm, formSyncId);
  //   FORM PROGRESS SYNC  END

  //   ADD EVENT LISTENER TO FORM
  selectedForm.addEventListener("submit", (e) => {
    // e.preventDefault();
    const button = document.querySelector(`#${formId} .submit-btn`);
    // console.log("ADD EVENT LISTENE", button);
    handleSubmitBtnState(button);
  });

  // SWEET ALERT
  const onOpenCb = () => {
    clearFormProgress(selectedForm, formSyncId);
  };
  showSwalMessage(swalAlertMsg, onOpenCb);
}

// HERO DROPDOWN
$("#countries").on("change", function () {
  const country = $(this).val();
  // REMOVE EXISTING URL IN THE PAGE AND ADD THE NEWLY REQUESTED LOCATION TO IT
  window.location = `${window.location.href.split("?")[0]}?country=${country}`;
});
